import {Component, effect, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {LayoutService} from "./service/app.layout.service";
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {LoginServices} from "../auth/login/services/login.service";
import {UserMenuService} from "../auth/login/services/usermenu.service";
import {PerfilServicesService} from "../users/perfil/services/perfil.service";
import {TramiteService} from "../users/tramites/services/tramite.service";
import {AppComponent} from "../app.component";
import {map} from "rxjs";
import {DraftProjectService} from "../users/proyectos/services/draft-project.service";

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {
    menu: MenuItem[] = [];
    totalTramitesCarrito: number = 0;
    imagenPerfil: string = ''
    @ViewChild('searchinput') searchInput!: ElementRef;
    @ViewChild('menubutton') menuButton!: ElementRef;
    searchActive: boolean = false;
    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));

    constructor(public layoutService: LayoutService, public tramite: TramiteService,
                public loginServices: LoginServices, private perfil: PerfilServicesService,
                private route: ActivatedRoute, private router: Router, private userMenuService: UserMenuService, public appComponent: AppComponent,
                private draftProjectService: DraftProjectService,) {
    }

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.preFetchProyectoId()
    }

    private preFetchProyectoId() {
        console.log(`preFetchProyectoId`)
        this.prjId$.subscribe((id) => {
            if (id) {//load everything prj sequence.
                this.tramite.idProyecto.set(id)
            }
        });
        console.log(`params -> this.tramite.idProyecto  -> ${this.tramite.idProyecto()}`)
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    calcularTotalTramites() {
        let total = 0
        for (let i of this.tramite.tramitesCarrito()) {
            total = total + parseFloat(i.tarifaTramite)
        }
        this.totalTramitesCarrito = total
    }

    completarPagos() {
        const id = this.tramite.idProyecto() ? this.tramite.idProyecto() : '';
        this.router.navigate(['/users/pagos/tramites', id]);
    }

    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }

    cerrarSesion() {
        this.loginServices.logout().subscribe()
        this.loginServices.removerSession();
        this.tramite.tramitesCarrito.set([])
        this.userMenuService.rutas.set([])
        sessionStorage.clear()
        localStorage.clear()
        localStorage.removeItem("draftProject")
        this.draftProjectService.draftProject.set(this.draftProjectService.resetDratfProject());
        this.router.navigated = false
        this.router.navigate(['/auth/login']).then(r => console.log("Sesión cerrada."));
    }

    deactivateSearch() {
        this.searchActive = false;
    }

    removeTab(event: MouseEvent, item: MenuItem, index: number) {
        this.layoutService.onTabClose(item, index);
        event.preventDefault();
    }

    get layoutTheme(): string {
        return this.layoutService.config.layoutTheme;
    }

    get colorScheme(): string {
        return this.layoutService.config.colorScheme;
    }

    get tabs(): MenuItem[] {
        return this.layoutService.tabs;
    }

    get logoCNR(): any {
        if (this.layoutService.config.colorScheme != undefined) {
            if (this.layoutService.config.colorScheme == "light") {
                return 'assets/demo/images/logos/dot_logo.png'
            } else if (this.layoutService.config.colorScheme == "dark") {
                return 'assets/demo/images/logos/dot_logo.png'
            }
        }
    }

    imagenPerfilEffect = effect(() => {
        this.imagenPerfil = this.perfil.imageDemo()
    })
    /**
     * Obtiene los trámites cargados en servicio de trámites y los filtra por los estados permitidos para mostrar en carrito.
     */
    tramitesCarritoEffect = effect(() => {
        console.log(`####################################################################`)
        console.log("tramitesCarritoEffect " + new Date().toISOString())
        if (this.tramite.tramitesCarrito()) {
            console.log(`Procesados  :${this.tramite.tramitesProcesados().length}`);
            console.log(`En carrito :${this.tramite.tramitesCarrito().length}`);
            this.calcularTotalTramites()
        }
    }, {allowSignalWrites: true})
}
